"use client";

import { format } from "date-fns";
import { useScopedI18n } from "@/messages/client";
import { DirectusImage } from "@/components/DirectusImage";
import { AspectRatio } from "@radix-ui/react-aspect-ratio";
import RouterLink from "@/components/ui/router-link";
import { useCurrentLocale } from "@/hooks/useCurrentLocale";
import Richtext from "../Richtext";
import { Fragment } from "react";
import Title from "@/components/ui/title";
import { getNewsHref } from "../NewsCover";

export type News = {
  slug?: string;
  category?: number;
  title?: string;
  cover?: string;
  content?: string;
  is_external?: boolean;
  external_link?: string;
  publish?: {
    publish_date?: string;
  }
}

export default function NewsDetailClient(props: {
  data?: News;
  dataList?: News[];
}) {
  const locale = useCurrentLocale();
  const t = useScopedI18n("新闻");
  return (
    <div className="w-full">
      <div className="flex flex-col items-center">
        <h1 className="text-2xl leading-normal text-center md:text-4xl md:max-w-[75%]">{props.data?.title}</h1>
        {props.data?.publish?.publish_date && (
          <span className="mt-6 text-xs text-zinc-400 md:mt-7 md:text-xl">
            {locale === "cn" && format(new Date(props.data.publish.publish_date), "yyyy年MM月dd日")}
            {locale !== "cn" && format(new Date(props.data.publish.publish_date), "yyyy-MM-dd")}
          </span>
        )}
      </div>
      {/* <div className="flex justify-between items-center gap-x-6 mt-4 w-full md:gap-x-16 md:mt-8">
        <hr className="border-zinc-400 grow" />
        <RouterLink
          target="_blank"
          className="grayscale duration-300 hover:grayscale-0"
        >
          <img
            className="w-6 md:w-10"
            src="/icon/zhihu.svg"
            alt="Icon Zhihu"
          />
        </RouterLink>
        <RouterLink
          target="_blank"
          className="grayscale duration-300 hover:grayscale-0"
        >
          <img
            className="w-6 md:w-10"
            src="/icon/wechat.svg"
            alt="Icon Wechat"
          />
        </RouterLink>
        <hr className="border-zinc-400 grow" />
      </div> */}
      <div className="w-full mt-7 md:mt-20">
        <Richtext
          data={{
            content: props.data?.content
          }}
        />
      </div>
      {!!props.dataList?.length && (
        <Fragment>
          <Title className="mt-10" title={t("相关新闻")} underline={false} />
          <div className="flex flex-col gap-y-4 mt-4 md:flex-row md:gap-x-5 md:mt-14">
            {props.dataList.map((el, index) => (
              <RouterLink
                key={index}
                className="group w-full md:w-1/3"
                target="_blank"
                href={getNewsHref(
                  el?.is_external,
                  el?.external_link,
                  el?.slug
                )}
              >
                {el?.cover && (
                  <AspectRatio className="overflow-hidden" ratio={1.9}>
                    <DirectusImage
                      className="w-full object-cover"
                      alt={el?.title || ""}
                      id={el?.cover}
                      fill
                      zoomInGroup
                    />
                  </AspectRatio>
                )}
                <div className="px-8 py-3 bg-zinc-50 md:py-5 group-hover:bg-zinc-100">
                  <p className="text-sm h-10 font-bold line-clamp-2 text-ellipsis md:text-base md:h-12">
                    {el?.title}
                  </p>
                  <div className="mt-3 text-xs text-zinc-400 md:text-base">
                    {el?.publish?.publish_date && (
                      <span>{format(new Date(el.publish.publish_date), "yyyy-MM-dd")}</span>
                    )}
                  </div>
                </div>
              </RouterLink>
            ))}
          </div>
        </Fragment>
      )}
    </div>
  )
}